import { gql } from "apollo-boost";

export const GET_DRILL_LIB = gql`
  query($drillId: Int, $drillName: String, $sportType: String) {
    allDrillLib(
      drillId: $drillId
      drillName: $drillName
      sportType: $sportType
    ) {
      edges {
        node {
          drillId
          drillName
          drillDesc
          drillPurpose
          videoUrl
          equipment
          sportType
          facility
          status
          tag
          level
          favoriteDrillLib {
            edges {
              node {
                id
                favdrillId
                userId
                drillId
              }
            }
          }
          user {
            userName
            userId
          }
        }
      }
    }
  }
`;
export const FAVORITE_DRILL_LIB_GET = gql`
  query allFavoriteDrillLib($userId: Int) {
    allFavoriteDrillLib(userId: $userId) {
      edges {
        node {
          id
          favdrillId
          userId
          drillId
          user {
            userName
            userId
          }
          updateDate
        }
      }
    }
  }
`;
